module.exports = __webpack_public_path__ + "img/slika2.760a3d29.jpg";